export enum SuccessOrderCreationMessageEnum {
  CASH = "barcode",
  BANKS = "banks",
}

export enum PaymentIniatorEnum {
  NEO_PAY = "neopay",
  MIP = "mip",
  KEVIN = "kevin",
}
export interface ICreateOrderPayload {
  cart_id: Array<number>;
  order_sum: string;
  cart_count: string;
  data_declaration: boolean;
  previous_month_payment?: boolean;
}

export interface IOrder {
  cart_id: number;
  cart_group_id: number;
  client_id: number;
  commission: string;
  sum: string;
  total: string;
  id: string;
  barcode: string | null;
  barcode_image: string | null;
  status_id: OrderStatusIdEnum;
  discount: string;
}

export interface ICashPaymentSuccessResponse {
  type: "cash";
  success: true;
  barcode: string;
  barcode_image: string;
  message: SuccessOrderCreationMessageEnum.CASH;
}

export interface IBank {
  bank_title: string;
  bank_key: string;
  bank_method: PaymentIniatorEnum;
  bank_client_id: boolean;
}
export interface IMIPPaymentSuccessResponse {
  type: "mip";
  success: true;
  message: SuccessOrderCreationMessageEnum.BANKS;
  banks: Array<IBank>;
}

export type TProccessPaymentMutationResponse = ICashPaymentSuccessResponse | IMIPPaymentSuccessResponse;

export interface ICancelOrderSuccessMutationResponse {
  message: string;
  success: true;
}

export interface IProcessPaymenetMutationPayload {
  id: string;
  paymentOption: PaymentOptionEnum;
}

export interface IBankPaymentPayload {
  bank: string;
  orderId: string;
  callbackUrl: string;
}

export interface IBankPaymentSuccessResponse {
  success: boolean;
  url: string;
}

export enum PaymentOptionEnum {
  CASH = "cash",
  MIP = "mip",
}

export enum OrderStatusIdEnum {
  CANCELED_MANUALLY = -2,
  CANCELED = -1,
  ACTIVE = 0,
  PAID = 1,
  PENDING = 2,
}
export type TGetPaymentOptions = Array<TGetPaymentOption>;

export type TGetPaymentOption = {
  active: boolean;
  daily_alert_limit: number;
  name: string;
  payment_type: string;
  id: string;
  type: string;
};
